export const ROL_SUPERADMIN = 4;
export const ROL_ADMIN = 3;
export const ROL_SELLER = 2;
export const ROL_USER = 2;
// export const SERVICE_URL = 'http://localhost:6300';
export const SERVICE_URL = 'https://zona-azul.e2w.es/api';
export const ALLOW_USER_ROLES = [ROL_SUPERADMIN, ROL_ADMIN];
export const TIME_LIMIT_MINUTES = 60;
